import React, { Component } from 'react';
import URL from './URL';
import Button from 'components/main/items/ui/Button';
import Input from 'components/main/items/ui/Input';
import {Motion, spring}  from 'react-motion';
import Linkify from 'react-linkify';


import tab_bar from 'resources/images/general/tab_bar.png';
import shadow from 'resources/images/general/shadow.png';
import triangle from 'resources/images/general/triangle.png';
import triangle_down from 'resources/images/general/triangle_down.png';
import icon_comment from 'resources/images/buttons/buttonIcons/comment_black.png';
import icon_audioComment from 'resources/images/buttons/buttonIcons/audioComment_black.png';
import icon_alert2 from 'resources/images/icons/alert2.png';
import icon_heart from 'resources/images/icons/heart.png';
import submitComment from 'resources/images/icons/submitComment.png';
import delete_chosen from 'resources/images/icons/delete_chosen.png';

class UI extends Component {
  url = new URL(this.props.app);
  buttons = new Button(this.props.app)
  inputs = new Input(this.props.app)

  UNSAFE_componentWillReceiveProps(newProps){
    this.init(newProps);
    this.checkUrl();
  }

  checkUrl(){
  //  console.log("state: ", this.state);
    if(this.state && this.state.filename){
      this.url.getUrl(this.state.filename, this.state.type);
    }else{
      //console.log('no filename in state');
    }
  }

  async setPhoto(url){
    const blob = await this.url.urlToBlob(url);
    this.actions.main.setPhoto({url: url, blob: blob});
  }

  init(props){
    this.app = props.app;
    this.ui = this.app.store.ui;
    this.bs = this.ui.basicStyle;
    this.store = this.app.store;
    this.func = this.app.functions;
    this.db = this.app.database;
    this.actions = this.app.actions;

    this.buttons.init(props.app);
    this.inputs.init(props.app);

    this.atHome = this.store.content.traces.length === 1;
    this.inSchool = this.store.content.traces[1] === 'school' || this.store.content.traces[2] === 'school';

    this.url.init(props.app);
  }

  key(){ return Math.round(Math.random() * 100000);  }

  async setListScroll(id){
    const scrollValue = await this.db.get(id);
    const list = document.getElementById(id);
    if(scrollValue && list){
      list.scrollTo(0, scrollValue);
    }
  }
  
  onScroll(id, onEnd, overFlowX){
    const list = document.getElementById(id);
    if(overFlowX){
      this.db.set(id, list.scrollLeft);
      if(list.offsetWidth + list.scrollLeft >= list.scrollWidth && onEnd){
        onEnd();
      }
    }
    else{
      this.db.set(id, list.scrollTop);
      if (list.offsetHeight + list.scrollTop >= list.scrollHeight && onEnd) {
        onEnd();
      }
    }
  }

  checkBox(text, checked, onCheck, color, checkBoxSize, _fontSize, reverse){
    const style = {...this.ui.styles.container,...this.ui.styles.area,...{
      width: '',
      //height: this.bs.height * 0.035,
      height: '',
      color: color? color: 'white',
      fontSize: _fontSize ? this.bs.height * _fontSize : this.bs.height * 0.02
    }}
    const checkBoxStyle = {
      width: checkBoxSize ? this.bs.height* checkBoxSize : this.bs.height * 0.025,
      height: checkBoxSize ? this.bs.height* checkBoxSize : this.bs.height * 0.025
    }
    return(
      <div style={style}>
        {!reverse && text}
        <input style={checkBoxStyle} type='checkbox' checked={checked} onChange={onCheck}/>
        {reverse && text}
      </div>
    )
  }

  animatedAlert(){
    const alertStyle = {
      width: '100%',
      height: '100%'
    }
    const option = {stiffness: 1000, damping: 5, precision: 0.05}
    return(
      <Motion defaultStyle={{ rotate: -45 }}
      style={{ rotate: spring(0, option) }}>
        {style=> <img style={{...alertStyle, ...{ transform: 'rotate(' + style.rotate + 'deg)'}}} src={icon_alert2} alt=''/> }
      </Motion>
    )
  }

  animatedHeart(scale, value, onClick){
    const heartStyle = {...this.ui.styles.container, ...{
      width: scale? scale[0]:'',
      height: scale? scale[1]:'',
      fontWeight: 'bold',
      color: 'white',
      cursor: 'pointer',
      fontSize: scale? scale[0]/2.5: this.bs.height * 0.04,
      backgroundImage: 'url(' + icon_heart + ')',
      userSelect: 'none'
    }}
    const option = {stiffness: 1000, damping: 5, precision: 0.05}
    return(
      <Motion defaultStyle={{ rotate: -45 }} key={value}
      style={{ rotate: spring(0, option) }}>
        {style=>
          <div style={{...heartStyle, ...{ transform: 'rotate(' + style.rotate + 'deg)'}}} onClick={onClick}>
            {value}
          </div>
        }
      </Motion >
    )
  }

  animatedDelete(scale, value, onClick){
    const heartStyle = {...this.ui.styles.container, ...{
      width: scale? scale[0]:'',
      height: scale? scale[1]:'',
      fontWeight: 'bold',
      color: 'white',
      cursor: 'pointer',
      fontSize: scale? scale[0]/2.5: this.bs.height * 0.04,
      backgroundImage: 'url(' + delete_chosen + ')',
      userSelect: 'none'
    }}
    const option = {stiffness: 1000, damping: 10, precision: 0.05}
    return(
      <Motion defaultStyle={{ rotate: -45 }} key={value}
      style={{ rotate: spring(0, option) }}>
        {style=>
          <div style={{...heartStyle, ...{ transform: 'rotate(' + style.rotate + 'deg)'}}} onClick={onClick}>
            {value}
          </div>
        }
      </Motion >
    )
  }

  animatedComment(scale, image, onClick){
    const commentStyle = {...this.ui.styles.container, ...{
      width: scale? scale[0]:'',
      height: scale? scale[1]:'',
      cursor: 'pointer',
      backgroundImage: 'url(' + image + ')',
      userSelect: 'none'
    }}
    return(
      <div style={{...commentStyle}} onClick={onClick}>
      </div>
    )
  }

  animatedSubmitComment(scale, onClick){
    const submitCommentStyle = {...this.ui.styles.container, ...{
      width: scale? scale[0]:'',
      height: scale? scale[1]:'',
      cursor: 'pointer',
      backgroundImage: 'url(' + submitComment + ')',
      userSelect: 'none',
    }}
    return(
      <div style={{...submitCommentStyle}} onClick={onClick}>
      </div>
    )
  }

  cardTags(commentOnClick, audioCommentOnClick){
    const width = this.bs.width * 0.05;
    const style = {...this.bs, ...{
      position: 'absolute',
      bottom: 0,
      right: 0,
      width: width,
      height: width * 2,
      justifyContent: 'flex-end'
    }}
    return(
      <div style={style}>
        {this.icon(icon_comment, [width, width], commentOnClick? 0.85:0.1, commentOnClick)}
        {this.icon(icon_audioComment, [width, width], audioCommentOnClick? 0.85:0.1, audioCommentOnClick)}
      </div>
    )
  }

  icon(url, scale, opacity, onClick){
    const iconStyle = {
      width: scale[0],
      height: scale[1],
      opacity: opacity,
      backgroundImage: 'url(' + url + ')',
      backgroundSize: '100% 100%',
      cursor: onClick? 'pointer': '',
      flexShrink: 0,
    }
    return <div style={iconStyle} onClick={onClick}/>
  }

  tabBar(title, hide, onClick){
    const barStyle = {
      backgroundImage: 'url(' + tab_bar + ')',
      backgroundSize: '100% 100%',
      width: '100%',
      height: this.bs.height * 0.05,
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0,
      cursor: onClick? 'pointer':'',
      position: 'relative'
    }
    const textStyle = {
      width: '90%',
      fontSize: this.bs.width * 0.03,
      fontWeight: 'bold',
      textOverflow: 'ellipsis',
      margin: '3%',
    }
    const tagSize = this.bs.height * 0.03;
    return(
      <div style={barStyle} onClick={onClick}>
       <div style={textStyle}>
        {this.func.multiLang(title[0], title[1], title[2])}
       </div>
       {onClick && <img src={hide? triangle:triangle_down} style={{opacity: 0.15, height: tagSize, width: tagSize}} alt=''/>}
       {this.shadow(this.bs.height * 0.05)}
      </div>
    )
  }

  shadow(top){
    const style = {
      width: '100%',
      height: this.bs.height * 0.015,
      position: 'absolute',
      top: top,
      pointerEvents: 'none',
      opacity: 0.5
    }
    return <img src={shadow} style={style} alt=''/>
  }

  detailText(text, id, scale, textAlign){
    return this.textDisplay(text, scale?scale:['100%',''], '125%', textAlign?textAlign:'center', 'black', id)
  }

  scrollableText(text, scale, fontSize){
    const style = {
      width: scale? scale[0]: '100%',
      height: scale? scale[1]: '',
      margin: '1%',
      fontSize: fontSize? fontSize: '100%',
      fontWeight: 'bold',
      textAlign: 'center',
      overflow: 'auto',
      overflowWrap: 'break-word',
      flexShrink: 0
    }
    return <div style={style}>{text}</div>
  }

  textDisplay(text, scale, fontSize, textAlign, color, key){
    const style = {
      width: scale? scale[0]: '100%',
      height: scale? scale[1]: '',
      margin: '1%',
      fontSize: fontSize? fontSize: '100%',
      fontWeight: 'bold',
      textAlign: textAlign? textAlign: 'center',
      overflow: 'hidden',
      overflowWrap: 'break-word',
      color: color? color: 'black',
      flexShrink: 0,
    }

    const componentDecorator = (href, text, key) =>{
      return (
        <a href={href} key={key} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
      )
    };

    return <div key={key} style={style}><Linkify componentDecorator={componentDecorator}>{text}</Linkify></div> 
  }

  subTitle(title, fontSize, textAlign){
    const subTitleStyle = {
      width: '100%',
      color: this.ui.colors.mlangGreen,
      fontSize: fontSize? fontSize:'110%',
      fontWeight: 'bold',
      textAlign: textAlign? textAlign:'center'
    }
    return <div style={subTitleStyle}>{this.func.multiLang(title[0], title[1], title[2])}</div>
  }

  gap(height){
    return <div style={{height: height, width: '100%', flexShrink: 0}} />
  }

  sep(){
    return <div style={{height: '1px', width: '100%', backgroundColor:'black', opacity: 0.15, flexShrink: 0}} />
  }

  verGap(width){
    return <div style={{minWidth: width, height: '100%', flexShrink: 0}}/>
  }

  verSep(color, height){
    return <div style={{backgroundColor: color, width: '1px', height: height, flexShrink: 0}}/>
  }

  filler(){ return <div style={{width: '100%', height: '100%'}}/> }

  failedMessage(message){
    this.actions.modal.message([message[0], message[1], message[2]]);
    this.actions.modal.showModalButton();
  }

  lastLoginText(lastLogin, fontSize){

    const lastLoginDate = new Date(lastLogin);
    var textColor = 'red';
    var displayText = '-';
    if(lastLogin){
      const current = new Date();
      const diffTime = Math.abs(current.getTime() - lastLoginDate.getTime());
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      const diffMins = Math.floor(diffTime / (1000 * 60));
      //console.log(diffMins);
      //console.log(diffDays);

      if(diffDays < 1){
        textColor = 'green';
      }else if(diffDays > 1 && diffDays < 7){
        textColor = 'grey';
      }

      if(diffMins < 60){
        displayText = diffMins + ' mins'
      }else if(diffMins < 1440){
        const diffHours = Math.floor(diffMins/60);
        displayText = diffHours + ' hrs'
      }else{
        displayText = diffDays + ' days'
      }

    }
    return this.textDisplay(displayText, [this.bs.height * 0.25,''], fontSize, 'left', textColor)

  }

}

export default UI;
